// Tag for graphql format
const gql = String.raw;

const getOnCreateAssignment = () => gql`
	subscription onCreatePayPlanAssignment {
		onCreatePayPlanAssignment {
			planId
			userId
			payPlanAssignment {
				_id
			}
			users {
				_id
				locationId
				employeeId
				fullName
				position
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
				currentPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					assignmentDate
					planId {
						_id
						name
						position
					}
					position
				}
				upcomingPayPlanAssignment {
					_id
					acknowledgementDate
					embeddedSigningLinks {
						url
						role
					}
					acknowledgementStatus {
						status
						statusDate
						statusMessage
						signingProgress {
							_id
							signedAt
							fullName
							roleId
						}
					}
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					planId {
						_id
						name
						position
					}
					effectiveDate
					position
				}
				payPlanAssignmentHistory {
					_id
					acknowledgementDate
					acknowledgementStatus {
						status
						statusDate
						signingProgress {
							_id
							signedAt
							fullName
							roleId
						}
					}
					embeddedSigningLinks {
						url
						role
					}
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					planId {
						_id
						name
						position
					}
					position
					packageId
				}
				supervisor {
					_id
					fullName
				}
				preferences {
					landingLocation
					landingPage
				}
				hireDate
			}
		}
	}
`;

const getOnRemoveUser = () => gql`
	subscription onRemoveUserPayPlanAssignment {
		onRemoveUserPayPlanAssignment {
			_id
			locationId
			employeeId
			fullName
			position
			communications {
				acceptsTxt
				communicationType
				usage
				value
			}
			currentPayPlanAssignment {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				effectiveDate
				assignmentDate
				planId {
					_id
					name
					position
				}
				position
			}
			upcomingPayPlanAssignment {
				_id
				acknowledgementDate
				embeddedSigningLinks {
					url
					role
				}
				acknowledgementStatus {
					status
					statusDate
					statusMessage
					signingProgress {
						_id
						signedAt
						fullName
						roleId
					}
				}
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				planId {
					_id
					name
					position
				}
				effectiveDate
				position
			}
			payPlanAssignmentHistory {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				acknowledgementStatus {
					status
					statusDate
					signingProgress {
						_id
						signedAt
						fullName
						roleId
					}
				}
				embeddedSigningLinks {
					url
					role
				}
				assignedBy
				assignmentDate
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
			}
			supervisor {
				_id
				fullName
			}
			preferences {
				landingLocation
				landingPage
			}
			hireDate
		}
	}
`;

const getOnUpdateUser = () => gql`
	subscription onUpdateUserPayPlanAssignment {
		onUpdateUserPayPlanAssignment {
			_id
			locationId
			employeeId
			fullName
			position
			communications {
				acceptsTxt
				communicationType
				usage
				value
			}
			currentPayPlanAssignment {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				effectiveDate
				assignmentDate
				planId {
					_id
					name
					position
				}
				position
			}
			upcomingPayPlanAssignment {
				_id
				acknowledgementDate
				embeddedSigningLinks {
					url
					role
				}
				acknowledgementStatus {
					status
					statusDate
					statusMessage
					signingProgress {
						_id
						signedAt
						fullName
						roleId
					}
				}
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				planId {
					_id
					name
					position
				}
				effectiveDate
				position
			}
			payPlanAssignmentHistory {
				_id
				acknowledgementDate
				acknowledgementDocumentLink
				assignedBy
				assignmentDate
				acknowledgementStatus {
					status
					statusDate
					signingProgress {
						_id
						signedAt
						fullName
						roleId
					}
				}
				effectiveDate
				planId {
					_id
					name
					position
				}
				position
			}
			hireDate
		}
	}
`;

const getAssignmentsSubscriptions = () => [
	{
		context: "onCreatePayPlanAssignment",
		query: getOnCreateAssignment(),
	},
	{
		context: "onRemoveUserPayPlanAssignment",
		query: getOnRemoveUser(),
	},
	{
		context: "onUpdateUserPayPlanAssignment",
		query: getOnUpdateUser(),
	},
];

export { getAssignmentsSubscriptions, getOnCreateAssignment, getOnRemoveUser };
